import { FC } from 'react'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { Progress } from 'antd'
import './index.less'

interface PerProgressBarProps {
  percent?: number
  tasksDone?: number
  tasksAll?: number
}
export const PerProgressBar: FC<PerProgressBarProps> = ({ percent, tasksDone, tasksAll }) => {
  const isPercent = percent !== undefined && percent >= 0 && !tasksDone && !tasksAll
  // Prevents errors when all props are used. (Only percent or the other two should be used.)
  // eslint-disable-next-line
  const isTask = tasksDone !== undefined && tasksDone >= 0 && tasksAll && tasksAll >= tasksAll && !percent

  const progressBarValue = () => {
    if (isPercent) {
      return percent
    }
    if (isTask && tasksDone !== undefined && tasksAll !== undefined && tasksAll !== 0) {
      return (tasksDone / tasksAll) * 100
    }
    return 0 // default
  }

  return (
    <PerFlexRow justify="space-between" align="middle" className="per-progress-bar">
      <Progress percent={progressBarValue()} showInfo={false} data-e2e-progressbar />
      <PerText fontSize="s" color={percent === 100 ? 'success' : percent === 0 ? 'error' : 'secondary'} ml="s">
        {isPercent && percent + ' %'}
        {isTask && (
          <>
            <PerText fontSize="xl" display="inline" color={tasksDone === 0 ? 'error' : tasksAll === tasksDone ? 'success' : 'warning'}>
              {tasksDone}
            </PerText>
            {' / ' + tasksAll}
          </>
        )}
      </PerText>
    </PerFlexRow>
  )
}
